import {useStyles} from '../../shared/hooks/styles';
import {useIsDesktop} from '../../shared/hooks/useIsDesktop';
import {DeviceSize} from '../../shared/theme/helpers';

export const useECertificatesStyles = () => {
  const isDesktop = useIsDesktop();

  return useStyles(({theme, mediaOnly, deviceSize}) => ({
    root: {
      width: '100%',
      marginHorizontal: 'auto',
      ...mediaOnly(DeviceSize.mobile, {paddingHorizontal: 16}),
      ...mediaOnly(DeviceSize.tablet, {paddingHorizontal: 35, maxWidth: 900}),
      ...mediaOnly(DeviceSize.desktop, {paddingHorizontal: 60, maxWidth: 1440}),
    },

    topBlock: {
      backgroundColor: theme.screen.container[deviceSize].backgroundColor,
      ...mediaOnly(DeviceSize.desktop, {marginTop: 30, marginBottom: 40}, {marginTop: 10}),
    },

    contentTextWrapper: {
      maxWidth: '90%',
      ...mediaOnly(DeviceSize.desktop, {marginBottom: 0}, {marginBottom: 30}),
    },

    bottomBlock: {
      ...mediaOnly(DeviceSize.desktop, {paddingBottom: 100}),
      ...mediaOnly(DeviceSize.tablet, {
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        alignSelf: 'center',
        paddingBottom: 100,
      }),
      ...mediaOnly(DeviceSize.mobile, {
        paddingBottom: 30,
      }),
      width: `100%`,
      marginTop: isDesktop ? 30 : 10,
    },

    tabsContainer: {
      marginBottom: 43,
      ...mediaOnly(DeviceSize.desktop, {display: 'flex', flexDirection: 'row'}),
      ...mediaOnly(DeviceSize.mobile, {display: 'flex', flexDirection: 'column'}),
    },

    card: {
      ...mediaOnly(DeviceSize.desktop, {marginBottom: 44}, {marginBottom: 20}),
    },
    title: {
      ...mediaOnly(DeviceSize.desktop, {flex: 1.5, marginTop: 40, marginBottom: 30}, {}),
      ...mediaOnly(DeviceSize.tablet, {flex: 2, marginLeft: 10}, {}),
    },

    programContentWithImageIcon: {
      marginTop: 80,
      marginRight: 105,
      width: 397,
      height: 352,
    },

    programContentWithImageBackground: {
      ...mediaOnly(DeviceSize.desktop, {top: 25, right: 54, width: 524, height: 536}, {}),
    },

    programContentWithImageContent: {
      ...mediaOnly(DeviceSize.mobile, {minHeight: 1}, {minHeight: 'auto'}),
    },
  }));
};
